function addMobileSpecificClass() {
  document.querySelector('body').classList.add('is-in-mobile-app');
}

function nativePostMessage(data) {
  return window.ReactNativeWebView ? window.ReactNativeWebView.postMessage(data) : window.postMessage(data);
}

function sendPostMessageOnLogout() {
  document.querySelectorAll('.js-logout, .js-log-out-link').forEach(logoutLink => {
    logoutLink.addEventListener('click', () => {
      const action = JSON.stringify({
        type: 'LOGOUT',
      });

      nativePostMessage(action);
    });
  });
}

function sendPostMessageOnUnitChange() {
  document.querySelectorAll('.js-switch-unit-button-link').forEach(unitLink => {
    const unitUrl = unitLink.href;
    unitLink.addEventListener('click', () => {
      const action = JSON.stringify({
        type: 'SWITCH_UNIT',
        payload: {
          unitUrl,
        }
      });

      nativePostMessage(action);
    });
  });
}

function addPmSessionLogoutWarning() {
  document.querySelectorAll('.js-logout-disabled').forEach(disabledLogoutLink => {
    disabledLogoutLink.addEventListener('click', () => {
      window.alert('As a property manager, you cannot logout of the online portal.');
    });
  });
}

function mobileAppInitializer() {
  const { userAgent } = window.navigator;
  const isUsingMobileApp = userAgent.includes('ResidentMobileApp') || userAgent.includes('APMMobileApp');

  if (isUsingMobileApp) {
    sendPostMessageOnLogout();
    addMobileSpecificClass();
    sendPostMessageOnUnitChange();
    addPmSessionLogoutWarning();
  }
}

export default mobileAppInitializer;
